/// Port of mobile/lib/app/remote_config/ui/server_unavailable_screen.dart.

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  startGateScreenPolling,
  useRemoteConfigStore,
} from '@/app/remote_config/handler/remoteConfigStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { useThemeColors } from '@/settings/handler/settingsStore';

export function ServerUnavailableScreen() {
  const { t } = useTranslation();
  const colors = useThemeColors();
  const refresh = useRemoteConfigStore((s) => s.refresh);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    void refresh();
    // Always poll while this screen is open (prod's 10-minute interval is too slow).
    const stop = startGateScreenPolling({ force: true });
    return stop;
  }, [refresh]);

  return (
    <div className="flex h-full items-center justify-center px-8" style={{ backgroundColor: colors.surface }}>
      <div className="flex max-w-sm flex-col items-center">
        <h1 className="leading-none" style={{ fontSize: 52, color: colors.onSurface }}>
          {t('appName')}
        </h1>
        <h2 className="mt-7 text-center leading-tight" style={{ fontSize: 28, color: colors.onSurface }}>
          {t('serverUnavailableTitle')}
        </h2>
        <p
          className="mt-3 text-center"
          style={{ fontSize: 14, lineHeight: 1.4, color: colors.onSurface, opacity: 0.7 }}
        >
          {t('serverUnavailableMessage')}
        </p>
        <div className="mt-8">
          <PixelContainer
            radius={9}
            pixelScale={2}
            padding="14px 28px"
            backgroundColor={colors.surfaceContainerHighest}
            borderColor={colors.surfaceContainerHighest}
            onClick={
              checking
                ? undefined
                : () => {
                    setChecking(true);
                    void refresh().finally(() => setChecking(false));
                  }
            }
          >
            <span className="leading-none" style={{ fontSize: 22, color: colors.onSurface }}>
              {checking ? t('offlineChecking') : t('offlineRetry')}
            </span>
          </PixelContainer>
        </div>
      </div>
    </div>
  );
}
